export const VIEWPORT_CONSTANTS = {
    /** Viewport width below which to treat as mobile. */
    MOBILE_BREAKPOINT: 768,
};
//# sourceMappingURL=viewportConstants.js.map